import { defineComponent as a, computed as l, openBlock as i, createElementBlock as c, createElementVNode as e, toDisplayString as d, createCommentVNode as m, normalizeStyle as h } from "vue";
const _ = ["viewBox"], f = /* @__PURE__ */ e("mask", { id: "bb164f24-5c31-4db2-bfda-8843e758b7e5" }, [
  /* @__PURE__ */ e("circle", {
    cx: "256",
    cy: "256",
    r: "256",
    fill: "#fff"
  })
], -1), u = { mask: "url(#bb164f24-5c31-4db2-bfda-8843e758b7e5)" }, z = { key: 0 }, p = /* @__PURE__ */ e("path", {
  fill: "#d80027",
  d: "M0 0h512v512H0z"
}, null, -1), k = /* @__PURE__ */ e("path", {
  fill: "#0052b4",
  d: "M256 70 5 256l251 186 251-186Z"
}, null, -1), v = /* @__PURE__ */ e("path", {
  fill: "#eee",
  d: "M256 130 85 256l171 126 171-126Zm-13.4-5.7 34.7-25h-42.7l34.7 25L256 83.7ZM46.5 277.4l27.2-33.1-41.4 11.1 40.1 15L49 234.6Zm419 0-27.2-33.1 41.4 11.1-40.1 15 23.4-35.8zm-145.7-104 27.2-33.1-41.4 11.1 40.1 15-23.4-35.8zm70.3 52 27.2-33.1-41.4 11.1 40.1 15-23.4-35.8zm-197.9-52L165 140.3l41.4 11.1-40.1 15 23.4-35.8zm-70.3 52-27.2-33.1 41.4 11.1-40.1 15 23.4-35.8zm-13 104 27.2-33.1-41.5 11.1 40.2 15-23.4-35.8zm70.3 52 27.2-33.1-41.4 11.1 40.1 15-23.4-35.8zm63.5 46.9 34.7-24.9h-42.7l34.7 24.9-13.3-40.6zm160.4-98.9-27.2-33.1 41.5 11.1-40.2 15 23.4-35.8zm-70.3 52-27.2-33.1 41.4 11.1-40.1 15 23.4-35.8z"
}, null, -1), g = /* @__PURE__ */ e("path", {
  fill: "#0052b4",
  d: "m242.7 204.7 34.7-25h-42.7l34.7 25-13.3-40.7zm-39.2 103 34.7-25h-42.7l34.7 25-13.3-40.7zm78.2 0 34.7-25h-42.7l34.7 25-13.3-40.7zm-39.1-4.4 34.7 25h-42.7l34.7-25L256 344ZM160 223h192v32H160z"
}, null, -1), b = { fill: "none" }, x = ["r"], B = /* @__PURE__ */ a({
  __name: "us-ar",
  props: {
    flagName: {},
    strokeColor: { default: "#000" },
    strokeWidth: { default: 0 }
  },
  setup(r) {
    const t = r, o = l(() => 512 + 2 * t.strokeWidth), s = l(() => -t.strokeWidth), n = l(() => 256 + t.strokeWidth / 2);
    return (w, y) => (i(), c("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "svg-circle-flags",
      viewBox: `${s.value} ${s.value} ${o.value} ${o.value}`
    }, [
      f,
      e("g", u, [
        t.flagName ? (i(), c("title", z, d(t.flagName), 1)) : m("", !0),
        p,
        k,
        v,
        g
      ]),
      e("g", b, [
        e("circle", {
          cx: "256",
          cy: "256",
          r: n.value,
          fill: "none",
          style: h({ stroke: t.strokeColor, strokeWidth: t.strokeWidth })
        }, null, 12, x)
      ])
    ], 8, _));
  }
});
export {
  B as default
};
//# sourceMappingURL=us-ar-06ee5adc.js.map
